import Administracao from '../pages/Administracao/Index.vue'
import IndicadoresPrevineBrasil from '../pages/Administracao/IndicadoresPrevineBrasil/Index.vue'
import GerenciarUsuarios from '../pages/Administracao/GerenciarUsuarios/Index.vue'
import Ressincronizacao from '../pages/Administracao/Ressincronizacao/Index.vue'

export default [
  {
    path: '/administracao',
    component: Administracao,
  },
  {
    path: '/indicadores-previne-brasil',
    component: IndicadoresPrevineBrasil,
  },
  {
    path: '/gerenciar-usuarios',
    component: GerenciarUsuarios,
  },
  {
    path: '/ressincronizacao',
    component: Ressincronizacao,
  },
  {
    path: '/gerenciar-permissoes',
    component: () =>
      import('@/pages/Administracao/GerenciarPermissoes/Index.vue'),
  },
  {
    path: '/gerenciar-logotipo',
    component: () =>
      import('@/pages/Administracao/GerenciarLogotipo/Index.vue'),
  },
  {
    path: '/gerenciar-brasao',
    component: () => import('@/pages/Administracao/GerenciarBrasao/Index.vue'),
  },
  {
    path: '/equipes-saude',
    component: () => import('@/pages/Administracao/Equipes/Index.vue'),
  },
  {
    path: '/profissionais-lotacoes',
    component: () =>
      import('@/pages/Administracao/ProfissionaisLotacoes/Index.vue'),
  },
  {
    path: '/escolas',
    component: () => import('@/pages/Administracao/Escolas/Index.vue'),
  },
]
